// components/StudentForm/PerformanceSection.jsx
import React, { useCallback } from 'react';

// StarRating is defined outside the parent and memoized
const StarRating = React.memo(({ score, onScoreChange, remarks, onRemarksChange, label, remarksName }) => {
  return (
    <div className="form-group">
      <label className="label">{label}</label>
      <div className="star-with-remarks">
        <div className="star-rating">
          {[...Array(10)].map((_, index) => {
            const value = index + 1;
            return (
              <span
                key={value}
                className={`star ${value <= score ? "filled" : ""}`}
                onClick={() => onScoreChange(value)}
                style={{ cursor: 'pointer' }}
              >
                ★
              </span>
            );
          })}
        </div>
        <input
          type="text"
          name={remarksName}
          value={remarks || ''}
          onChange={onRemarksChange}
          placeholder={`Add remarks for ${label.toLowerCase()}`}
          className="star-input"
        />
      </div>
    </div>
  );
});

const PerformanceSection = ({ formData, onFormDataChange, isExpanded = true }) => {
  // stable generic handler
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    onFormDataChange(prev => ({ ...prev, [name]: value }));
  }, [onFormDataChange]);

  // stable specific handlers for star clicks / remarks
  const setTechnicalScore = useCallback((value) => {
    onFormDataChange(prev => ({ ...prev, technicalScore: value }));
  }, [onFormDataChange]);

  const setCommunicationScore = useCallback((value) => {
    onFormDataChange(prev => ({ ...prev, communicationScore: value }));
  }, [onFormDataChange]);

  const onTechnologyRemarksChange = useCallback((e) => {
    onFormDataChange(prev => ({ ...prev, technologyRemarks: e.target.value }));
  }, [onFormDataChange]);

  const onCommunicationRemarksChange = useCallback((e) => {
    onFormDataChange(prev => ({ ...prev, communicationRemarks: e.target.value }));
  }, [onFormDataChange]);

  return (
    <div className="form-section">
        <div className="section-content">
          <div className="form-row">
            <StarRating
              score={formData.technicalScore || 0}
              onScoreChange={setTechnicalScore}
              remarks={formData.technologyRemarks}
              onRemarksChange={onTechnologyRemarksChange}
              label="Technology Score"
              remarksName="technologyRemarks"
            />

            <StarRating
              score={formData.communicationScore || 0}
              onScoreChange={setCommunicationScore}
              remarks={formData.communicationRemarks}
              onRemarksChange={onCommunicationRemarksChange}
              label="Communication Score"
              remarksName="communicationRemarks"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="label">
                Mock Interview <span className="mandatory">*</span>
              </label>
              <select
                name="mockInterview"
                value={formData.mockInterview || ''}
                onChange={handleChange}
                required
                className="input select"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {formData.mockInterview === "Yes" && (
              <div className="form-group">
                <label className="label">
                  Mock Interview Remarks <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  name="mockRemarks"
                  value={formData.mockRemarks || ''}
                  onChange={handleChange}
                  required
                  className="input"
                  placeholder="Enter remarks"
                />
              </div>
            )}
          </div>
        </div>
    </div>
  );
};

export default PerformanceSection;